import _ from 'lodash'

import { OSTYPE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: OSTYPE_MNG,
  callBackAction: 'osTypeCopy',
  params: {},
  okAction: 'copyOsType',
  toolbar: {},
  needFetchFillInfo: false,
  formatData(data) {
    let copyObj = { sourceProductId: data.sourceProductId, targetProductId: data.targetProductId }
    data.copyMultiOsTypeList = [copyObj]
    return data
  },
  view: {
    labelPosition: 'right',
    labelWidth: '225px',
    content: [
      {
        $id: 'sourceProductId',
        $type: 'select',
        label: '源版本',
        $el: {
          clearable: true,
          filterable: true
        },
        $options: OSTYPE_MNG + '/findProductForOsType',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.productVersion
            }
          })
          return value
        },
        rules: [
          {
            notEmpty: '源版本'
          }
        ]
      },
      {
        $id: 'targetProductId',
        $type: 'select',
        label: '复制到目标版本',
        $el: {
          clearable: true,
          filterable: true
        },
        $options: 'product/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.productVersion
            }
          })
          return value
        },
        rules: [
          {
            notEmpty: '复制到目标版本'
          }
        ]
      }
    ]
  }
}
